import { Recipe } from "./types";

// Extras Recipes - Single source of truth for all extras descriptions
export const extrasRecipes: Record<string, Recipe> = {
  tzatziki: {
    id: "tzatziki",
    name: "Tzatziki",
    nameFr: "Tzatziki",
    nameKey: "recipes.tzatziki.name",
    description:
      "A cool and creamy Greek yogurt dip blended with fresh cucumber, garlic, lemon, and herbs. Perfect as a refreshing accompaniment",
    descriptionFr:
      "Une sauce grecque crémeuse à base de yogourt, rehaussée de concombre frais, d’ail, de citron et d’herbes. Un accompagnement frais et savoureux",
    descriptionKey: "recipes.tzatziki.description",
  },

  taramosalata: {
    id: "taramosalata",
    name: "Taramosalata",
    nameFr: "Taramosalata",
    nameKey: "recipes.taramosalata.name",
    description:
      "A traditional Greek dip made with salted fish roe, blended with lemon, olive oil, and creamy bread for a rich, savory flavor",
    descriptionFr:
      "Un classique grec préparé avec du œufs de poisson salés, mélangés à du citron, de l’huile d’olive et du pain pour une texture riche et savoureuse",
    descriptionKey: "recipes.taramosalata.description",
  },

  "mushroom-sauce": {
    id: "mushroom-sauce",
    name: "Mushroom Sauce",
    nameFr: "Sauce aux champignons",
    nameKey: "recipes.mushroomSauce.name",
    description:
      "A rich, velvety sauce made with sautéed mushrooms, herbs, and cream. Ideal for steaks, chicken, or sides",
    descriptionFr:
      "Une sauce riche et veloutée préparée avec des champignons sautés, des herbes et de la crème. Parfaite pour les viandes ou les accompagnements",
    descriptionKey: "recipes.mushroomSauce.description",
  },

  "pepper-sauce": {
    id: "pepper-sauce",
    name: "Pepper Sauce",
    nameFr: "Sauce au poivre",
    nameKey: "recipes.pepperSauce.name",
    description:
      "A bold and creamy peppercorn sauce with a warm, savory finish. A classic accompaniment to grilled meats",
    descriptionFr:
      "Une sauce crémeuse aux grains de poivre offrant une finition chaude et savoureuse. Un accompagnement classique pour les viandes grillées",
    descriptionKey: "recipes.pepperSauce.description",
  },

  vinaigrette: {
    id: "vinaigrette",
    name: "Vinaigrette",
    nameFr: "Vinaigrette",
    nameKey: "recipes.vinaigrette.name",
    description:
      "A house-made vinaigrette crafted with quality oil, vinegar, herbs, and a touch of seasoning. Light and well-balanced",
    descriptionFr:
      "Une vinaigrette maison préparée avec une huile de qualité, du vinaigre, des herbes et un assaisonnement délicat. Légère et équilibrée",
    descriptionKey: "recipes.vinaigrette.description",
  },

  "butterfly-shrimp": {
    id: "butterfly-shrimp",
    name: "Butterfly Shrimp",
    nameFr: "Crevette papillon",
    nameKey: "recipes.butterflyShrimp.name",
    description:
      "Tender shrimp split and prepared butterfly-style for a delicate texture and refined flavor",
    descriptionFr:
      "De tendres crevettes ouvertes en papillon, offrant une texture délicate et une saveur raffinée",
    descriptionKey: "recipes.butterflyShrimp.description",
  },

  langoustine: {
    id: "langoustine",
    name: "Langoustine",
    nameFr: "Langoustine",
    nameKey: "recipes.lobsterExtra.name",
    description:
      "A premium langoustine portion offering sweet, delicate seafood flavor, a luxurious upgrade to any dish",
    descriptionFr:
      "Une portion de langoustine offrant une saveur délicate et sucrée, un ajout luxueux à tout plat",
    descriptionKey: "recipes.lobsterExtra.description",
  },

  scallop: {
    id: "scallop",
    name: "Scallop",
    nameFr: "Pétoncle",
    nameKey: "recipes.scallop.name",
    description:
      "A tender, buttery scallop with a naturally sweet, delicate flavor, an elegant seafood extra",
    descriptionFr:
      "Un pétoncle tendre et beurré, naturellement sucré et délicat, un extra de fruits de mer élégant",
    descriptionKey: "recipes.scallop.description",
  },

  "frog-leg": {
    id: "frog-leg",
    name: "Frog Leg",
    nameFr: "Cuisse de grenouille",
    nameKey: "recipes.frogLeg.name",
    description:
      "A lightly seasoned frog leg offering a tender texture and mild flavor, traditionally enjoyed as a gourmet delicacy",
    descriptionFr:
      "Une cuisse de grenouille légèrement assaisonnée, tendre et au goût délicat, appréciée comme une délicatesse gastronomique",
    descriptionKey: "recipes.frogLeg.description",
  },

  "feta-cheese": {
    id: "feta-cheese",
    name: "Feta Cheese",
    nameFr: "Fromage feta",
    nameKey: "recipes.fetaCheese.name",
    description:
      "A portion of rich, tangy feta cheese, perfect as a topping or flavorful side",
    descriptionFr:
      "Une portion de fromage feta riche et acidulé, parfaite comme garniture ou accompagnement savoureux",
    descriptionKey: "recipes.fetaCheese.description",
  },
};
